<template>
  <div>
    <h5 class="p-1 text-center">Daftar Laporan</h5>
    <div>
      <div class="row mb-3 mt-3">
        <div class="col-12">
          <div class="search">
            <input
              type="text"
              name="namamasjid"
              id="namamasjid"
              class="form-control"
              placeholder="Teks Pencarian"
              v-model="searchRegistered"
            />
          </div>
        </div>
        <div class="col-12 mt-3">
          <button class="btn btn-main btn-search" @click="filterRegister">
            Cari Data <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <hr style="border: none; border-bottom: 1px solid #ccc" />

      <div class="mb-5" v-if="registered.length > 0">
        <a
          href="#"
          v-for="register in registered"
          :key="register.id"
          class="box-masjid shadow-sm"
        >
          <div class="status">
            <div class="row mb-2">
              <div class="col-8">
                Sumber:
                <strong>{{ register.pic_fullname }}</strong> <br />
                Penanggung Jawab:
                <strong>{{ register.pic_fullname }}</strong>
                <br />
                Tanggal Pelaksanaan:
                <strong>{{ register.implement_date }}</strong>
              </div>
              <div class="col-4" style="text-align: right">
                <span class="label" :class="loadLabel(register.status)">
                  <strong>{{ loadStatus(parseInt(register.status)) }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="masjid-title">
            {{ register.name }}
          </div>
          <div class="alamat">
            {{ register.address }}
          </div>
          <div class="d-flex">
            <div class="mx-1">
              <span class="label success" @click="toView(register.id)">
                View <i class="fa fa-eye"></i>
              </span>
            </div>
            <div class="mx-1">
              <span class="label process" @click="toEdit(register.id)">
                Edit <i class="fa fa-pen"></i>
              </span>
            </div>
          </div>
        </a>
      </div>
      <div v-else>
        <div class="mb-5 mt-3 alert alert-warning">
          <center>Tidak ada data.</center>
        </div>
      </div>
      <a
        v-if="registered.length > 5"
        href="#"
        class="btn btn-main btn-full"
        @click="loadRegistered"
        >Lainnya</a
      >
    </div>
  </div>
</template>

<script>
import axios from '../../utils/masjedapi';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      registered: [],
      verified: [],
      lastdate: '',
      lastdateVerified: '',
      reffcode: '',
      namamasjid: '',
      filterRegistered: '',
      searchRegistered: '',
      searchStartDate: '',
      searchEndDate: '',
      searchVerified: '',
      registered_stat: 0,
      verified_stat: 0,
      rejected_stat: 0,
      lastPage: 1,
      currentPage: 1,
    };
  },
  methods: {
    loadStatus(status) {
      switch (status) {
        case 0:
          return 'Menunggu Validasi';
        case 1:
          return 'Valid';
        default:
          break;
      }
    },
    loadLabel(status) {
      switch (status) {
        case 0:
          return 'process';
        case 1:
          return 'success';
        default:
          break;
      }
    },
    filterRegister() {
      this.currentPage = 1;
      this.registered = [];
      this.loadRegistered();
    },
    loadRegistered() {
      let status = '';
      const ref_code = this.$route.params.ref_code;
      const self = this;

      if (this.filterRegistered != '') {
        status = this.filterRegistered;
      }

      var url = `/laporkan?page=${self.currentPage}&code=${ref_code}`;

      if (this.searchRegistered != '')
        url = `${url}&search=${this.searchRegistered}`;
      if (this.searchStartDate != '') {
        url = `${url}&startdate=${moment(this.searchStartDate).format(
          'YYYY-MM-DD'
        )}`;
      }
      if (this.searchEndDate != '') {
        url = `${url}&enddate=${moment(this.searchEndDate).format(
          'YYYY-MM-DD'
        )}`;
      }

      axios.get(url).then(function (response) {
        const { data } = response.data;
        const listData = data.data || null;
        self.lastPage = data.last_page || 1;
        self.currentPage = data.current_page || 1;

        if (listData.length > 0) {
          const currentValue = self.registered;
          listData.forEach((item) => {
            self.registered.push(item);
          });
          self.currentPage = self.currentPage + 1;
        } else {
          self.currentPage = data.last_page + 1;
        }
      });
    },
    toView(id) {
      const { ref_code } = this.$route.params;
      this.$router.push({
        name: 'laporkan-view',
        params: {
          ref_code,
          id,
        },
      });
    },
    toEdit(id) {
      const { ref_code } = this.$route.params;
      this.$router.push({
        name: 'laporkan-update',
        params: {
          ref_code,
          id,
        },
      });
    },
  },
  mounted() {
    this.loadRegistered();
    this.reffcode = this.$route.params.ref_code;
  },
};
</script>

<style lang="scss" scoped>
.nav-tabs {
  border: none !important;
  .nav-item {
    flex: 1 !important;
    padding: 2px !important;

    .nav-link {
      border: none !important;
      width: 100% !important;
    }

    .active {
      font-weight: bold !important;
    }
  }
}

.tab-content {
  padding: 10px;
}

.box-masjid {
  display: block;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  margin-top: 20px;
  text-decoration: none;
  color: #000;

  .masjid-title {
    font-weight: bold;
    font-size: 18px;
    padding: 5px 0px;
  }
  .img {
    background: #ccc;
    height: 190px;
    overflow: hidden;
    border-radius: 5px;

    img {
      display: block;
      object-fit: cover;
      height: 100%;
      width: 100%;
    }
  }

  .status {
    font-size: 12px;
  }
}

.label {
  color: #fff;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 11px;
}

.process {
  background: #a79a28;
}

.success {
  background: #28a745;
}

.danger {
  background: #a72828;
}

.search {
  position: relative;
  input {
    padding-right: 75px;
  }
}

.btn-search {
  border-radius: 20px;
  width: 100% !important;
}

.pengajuan {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  padding: 5px 0px;

  .item {
    flex: 1;
  }
  .title {
    font-size: 12px;
    padding: 0px;
    margin: 0px;
    text-align: center;
  }
  .value {
    font-size: 25px !important;
    font-weight: normal;
    padding: 5px 0px;
    text-align: center;
  }
}

.status-wrapper {
  font-size: 12px;
}
</style>
